import React, { useState, useRef, useEffect } from 'react';
import themes from '../../../utils/themes';
import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';
import StyledCheckbox from '../checkbox/StyledCheckbox';
import { CustomDropdownStyle } from '../styledComponents/StyledCustomDropdown';
import StyledSearchInput from '../styledComponents/StyledSearchInput';

const StyledNewTagsSearch = ({
  options = [],
  onChange,
  finalValues,
  isMulti,
  name,
  ...props
}) => {
  const [search, setSearch] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownRef = useRef(null);

  const handleInputChange = (e) => {
    setSearch(e.target.value);
    setShowDropdown(!!e.target.value);
  };

  const handleMenuItemClick = (option) => {
    setSearch('');
    onChange(option);
    setShowDropdown(false); // Close the dropdown after clicking on a menu item
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const getOptions = (_search, _options = []) => {
    const options = _options.filter((option) =>
      option?.label?.toLowerCase()?.includes(_search),
    );

    return options.map((option, index) => (
      <Dropdown.Item
        key={`${option.id}-${index}`}
        onClick={() => handleMenuItemClick(option)}
        className={`${option?.enabled ? 'active' : ''}`}
      >
        <StyledCheckbox
          color
          bgColor={option?.enabled ? 'white' : 'primary'}
          iconColor={!option?.enabled ? 'white' : 'primary'}
          value={option?.enabled ? true : false}
          onChange={() => handleMenuItemClick(option)}
        />
        <span>{option?.label || ''}</span>
      </Dropdown.Item>
    ));
  };
  return (
    <>
      <CustomDropdownStyle
        toggleClassName="table-dropdown ms-0 table-text new-font p-0 border-0"
        className="custom-drop-down custom-drop-down-width table-dropdown-custom topic-dropdown bg-white p-0 border-0"
        dropDownProps="p-0 border-0"
        dropdownToggle={
          <StyledSearchDropDownInput
            name={name ? `input_${name}` : ''}
            padding="8px 16px"
            width="100%"
            stroke={themes.dark70}
            value={isMulti ? search : finalValues?.name}
            className="_search-input w-100"
            searchIconClassName="search-icon dark40"
            placeHolder="Search by Tags"
            $phFontSize="16px"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            onInput={handleInputChange}
            onReset={() => {
              setSearch('');
              setShowDropdown(false);
            }}
            $phColor={'dark60'}
            $iconColor="icon"
            svgSize={'24px'}
            {...props}
          />
        }
        menuClassName="checkbox-dropdown"
        drop="down"
        show={showDropdown}
        dropdownMenu={
          <StyledDropDownMenu
            ref={dropdownRef}
            name={'dropdown' + name ? `dropdown_${name}` : ''}
          >
            <div className="_options">
              {getOptions(search?.toLowerCase(), options)}
            </div>
          </StyledDropDownMenu>
        }
      />
    </>
  );
};

const StyledSearchDropDownInput = styled(StyledSearchInput)`
  width: 100%;
`;

const StyledDropDownMenu = styled.div`
  ._options {
    max-height: 200px;
    min-height: 50px;
    overflow-y: auto;
  }
  .input-container {
    margin: 16px 24px 12px;
  }
  .dropdown-item {
    display: flex;
    gap: 8px;
    border: 0 !important;
    padding: 6px 24px !important;
    &.active {
      color: ${({ theme }) => theme.white} !important;
      background-color: ${({ theme }) => theme.primary} !important;
      :hover {
        color: ${({ theme }) => theme.white} !important;
        background-color: ${({ theme }) => theme.primary} !important;
      }
    }
  }
};
`;
export default StyledNewTagsSearch;
